module.exports = __webpack_public_path__ + "img/oval_pt_slt_setsku.prt.04a730ee.jpg";